import {useInfiniteQuery} from "@tanstack/react-query";
import {PaginatedResponseType} from "../Types/Response/PaginatedResponseType";
import axiosAuthorised, { DEV_OVERRIDE_HEADER } from './AxiosAuthorised';
import {PostageUsageType} from "../Types/PostageType";
import { PaginationPageParameters } from './PaginationHelpers';

const useInfinitePostage = (countryCode: string, usageType: PostageUsageType) => {
    let parsedCode = countryCode ? countryCode : 'GB';

    const baseUrl = `${process.env.REACT_APP_API_HOST}/client/v1.1/postage-options?offset=0&limit=100&countryCode=${parsedCode}&PostageOptionUsageType=${usageType}`;

    return useInfiniteQuery(
        ['postageOptions', parsedCode],
        async ({ pageParam = baseUrl }) => {
            const { data } : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam, DEV_OVERRIDE_HEADER);
            return data;
        },
        {
            ...PaginationPageParameters,
            cacheTime: 0,
        },
    );
}

export { useInfinitePostage }
